export default {
  org: {
    owner: 'Exec viewer',
    ownerDescription: 'Full view only access of all organisation, projects and site information.',
    admin: 'Admin',
    adminDescription:
      'Full access to all organisation projects and sites, including management of users.',
    finOff: 'Finance Officer',
    finOffDescription:
      'Organisation-level finance officer responsible for payment request approval and financial oversight.',
    finAdmin: 'Finance Admin',
    finAdminDescription:
      'Organisation-level finance administrator responsible for managing payment request metadata, AP accounts, and financial documentation.',
    member: 'Member',
    memberDescription: 'Access only to assigned projects and sites.',
  },
  boq: {
    owner: 'BOQ owner',
    ownerDescription: 'Full ownership and control of BOQ documents and related processes',
    admin: 'BOQ admin',
    adminDescription: 'Administrative access to BOQ management and approval workflows',
    catalogAdmin: 'BOQ catalog admin',
    catalogAdminDescription:
      "Manages the central vendor catalog, and the vendors of the user's own organisation",
  },
  project: {
    manager: 'Project Manager',
    managerDescription: 'Full edit access to all project information and sites.',
    member: 'Project member',
    memberDescription: 'Can view and contribute to project activities with standard permissions',
    professional: 'Project Professional',
    professionalDescription:
      'Review client variations and view access of all projects and site selling BOQ.',
    procOff: 'Project Procurement Officer',
    procOffDescription:
      'Manage vendors, add vendor items, and approve orders across all project sites.',
    client: 'Project Client',
    clientDescription: 'Review client variations and all project site progress.',
    clientWithApprovals: 'Project Client with approvals',
    clientWithApprovalsDescription:
      'Review and approve project client variations and all project site progress.',
    // Localised rather than stripped off the names above — see `getProjectRoleShortName`.
    short: {
      manager: 'Manager',
      member: 'Member',
      professional: 'Professional',
      procOff: 'Procurement Officer',
      client: 'Client',
      clientWithApprovals: 'Client with approvals',
    },
  },
  site: {
    admin: 'Site Administrator',
    adminDescription: 'Full access to site information, users, vendors, and site details.',
    member: 'Site Member',
    memberDescription: 'Standard site access for general activities and collaboration',
    procOff: 'Site Procurement Officer',
    procOffDescription: 'Manage vendors, add vendor items, and approve site orders.',
    finOff: 'Site Finance Officer',
    finOffDescription: 'Verifies site payment requests, and manages cashflow and overheads.',
    paymentOff: 'Site Payment Officer',
    paymentOffDescription:
      'Controls and manages all payments and approvals for payments of the site.',
    fieldUser: 'Site Worker',
    fieldUserDescription:
      'Access to create and view site BOQ, request orders, and log site deliveries.',
    professional: 'Site Professional',
    professionalDescription: 'Review client variations and view access of the site selling BOQ.',
    client: 'Site Client',
    clientDescription: 'Review client variations and site progress.',
    clientWithApproval: 'Site Client with approvals',
    clientWithApprovalDescription: 'Review and approve client variations and site progress.',
  },
};
